import moment from "moment";
class Employees {
  constructor(
    id,
    from,
    to,
    segmentId,
    segementDesploy,
    segmentName,
    name,
    file
  ) {
    this.id = id;
    this.from = from;
    this.to = to;
    this.segmentId = segmentId;
    this.segementDesploy = segementDesploy;
    this.segmentName = segmentName;
    this.name = name;
    this.file = file;
    this.formattedDesde = moment(from, "YYYY-MM-DD").format("DD-MM-YYYY");
    this.formattedHasta =
      to !== null ? moment(to, "YYYY-MM-DD").format("DD-MM-YYYY") : "";
  }

  static fromJson({
    empId,
    fecDesde,
    fecHasta,
    segmId,
    segmDespl,
    segmNombre,
    empNombre,
    legajo,
  }) {
    return new Employees(
      empId,
      fecDesde,
      fecHasta,
      segmId,
      segmDespl,
      segmNombre,
      empNombre,
      legajo
    );
  }
}

export default Employees;
